export default __webpack_public_path__ + "static/media/error_red.05dcb959.svg";